export default __webpack_public_path__ + "static/learn-submenu-0b5bbeb29cbf12b658d6d5ac5cfde3ad.png";